import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonGroup } from "rsuite";
import DataImportSteps from "./DataImportSteps";
import SelectDataSource from "./SelectDataSource";
import { SaveMetadata } from "./SaveMetadata";
import { useState } from "react";
import Instagram from "./Instagram";
import Amazon from "./Amazon";
import Google from "./Google";
import FileInput from "./FileInput";
import { InstagramProfileMetadataExtractor } from "../../utils/dataimport/extractors/instagram";
import { useTranslation } from "react-i18next";
function disablePrev(step) {
    return step === 0;
}
function getExtractor(dataSource) {
    if (dataSource === InstagramProfileMetadataExtractor.dataSource) {
        return new InstagramProfileMetadataExtractor();
    }
    else {
        const message = `ZIP profile extraction for "${dataSource}" is not yet implemented!`;
        alert(message);
        throw new Error(message);
    }
}
function disableNext(step, dataSource, uploadStarted, metadataExtracted) {
    if (step > 3)
        return true;
    else if (!dataSource)
        return true;
    else if (step > 1 && !uploadStarted)
        return true;
    else
        return false;
}
function ImportData() {
    const { t } = useTranslation();
    const [step, setStep] = useState(0);
    const [dataSource, setDataSource] = useState("");
    const [uploadStarted, setUploadStarted] = useState(false);
    const [metadata, setMetadata] = useState();
    const [metadataExtracted, setMetadataExtracted] = useState(false);
    const onNext = () => onChange(step + 1);
    const onPrevious = () => onChange(step - 1);
    const onChange = (nextStep) => {
        setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
    };
    const handleUploadFinished = async (files) => {
        for (const file of files) {
        }
        if (files) {
            const extractor = getExtractor(dataSource);
            const metadata = await extractor.extract(files);
            if (metadata) {
                setMetadata(metadata);
                onNext();
            }
        }
    };
    function handleSaveMetadata(_) {
        alert("Saving to the Dwinity network not yet implemented!");
    }
    return (_jsxs("div", { style: { color: "var(--text-brand-primary)", maxWidth: "800px" }, children: [_jsx("div", { style: { height: "35px" } }), _jsx(DataImportSteps, { step: step }), _jsx("hr", {}), step === 0 && _jsx(SelectDataSource, { dataSource: dataSource, setDataSource: setDataSource }), step === 1 && dataSource === "instagram" && _jsx(Instagram, {}), step === 1 && dataSource === "amazon" && _jsx(Amazon, {}), step === 1 && dataSource === "google" && _jsx(Google, {}), step === 2 && _jsx(FileInput, { onUploadFinished: handleUploadFinished }), step === 3 && _jsx(SaveMetadata, { metadata: metadata }), _jsx("hr", {}), step < 3 && (_jsxs(ButtonGroup, { children: [_jsx(Button, { onClick: onPrevious, disabled: disablePrev(step), className: "button brand large", children: t("common.buttons.previous") }), _jsx(Button, { onClick: onNext, disabled: disableNext(step, dataSource, uploadStarted, metadataExtracted), className: "button brand large", children: t("common.buttons.next") })] })), step === 3 && (_jsx(ButtonGroup, { children: _jsx(Button, { onClick: handleSaveMetadata, className: "button brand large", children: t("dataImport.steps.saveMetadata") }) }))] }));
}
export default ImportData;
